import classNames from "classnames";
import {ElementType, ForwardedRef, forwardRef, ReactElement, RefAttributes} from "react";

import Button from "@/components/button/Button.tsx";
import {ButtonProps} from "@/components/button/Button.types.ts";
import {Icon} from "@/components/icon/Icon.tsx";
import {IconButtonProps} from "@/components/iconButton/IconButton.types.ts";

import styles from "./IconButton.module.scss";

export type IconButtonComponent = {
  <T extends ElementType = "button">(props: IconButtonProps<T> & RefAttributes<T>): ReactElement;
  displayName?: string;
};

// No idea why this is not working with icon as a required prop. I am missing something with typing and forward refs.
// Types of parameters __0 and props are incompatible.
//   Type Omit<IconButtonProps<ElementType>, "ref"> is not assignable to type IconButtonProps<ElementType>
// Property icon is missing in type Omit<IconButtonProps<ElementType>, "ref"> but required in type IconButtonBaseProps

// This is a button that has ONLY an icon it, nothing else.
// If you require text or multiple icons or anything else, use the Button component instead.
// It should be very rare to use the icon props directly. If you are reusing the same icons props in multiple places, consider creating a new IconButton variant instead.
export const IconButton: IconButtonComponent = forwardRef(
  // @ts-expect-error invalid type assignment
  <T extends ElementType = "button">(
    {icon, size = "small", className, iconProps, ["aria-disabled"]: ariaDisabled, ...rest}: IconButtonProps<T>,
    ref: ForwardedRef<T>
  ) => {
    return (
      <Button
        className={classNames(className, styles[size])}
        disabled={ariaDisabled}
        size={size}
        ref={ref}
        {...(rest as ButtonProps<T>)}
      >
        <Icon icon={icon} {...iconProps} />
      </Button>
    );
  }
) as IconButtonComponent;
